module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('default-layout', [_c('div', {
    staticClass: "grid grid-cols-4"
  }, [((_vm.googleClassroomIntegration || _vm.edLinkIntegrations) && _vm.activityID) ? _c('div', {
    staticClass: "col-start-2 col-end-4"
  }, [_c('div', {
    staticClass: "mt-10 text-base font-semibold"
  }, [_vm._v("\n        Parlay needs you to connect to your account to the following system(s)\n        before joining this course. Click the “Connect” button to do this, and\n        then press the “Go To RoundTable” button once you are connected.\n      ")]), _vm._v(" "), (_vm.googleClassroomIntegration) ? _c('div', [_c('integration-student-card', {
    attrs: {
      "title": _vm.google_classroom_title,
      "icon": _vm.google_classroom_icon,
      "code": _vm.google_classroom_code
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.edLinkIntegrations) ? _c('div', _vm._l((_vm.rt_integrations), function(integration, key) {
    return _c('div', {
      key: key
    }, [_c('integration-student-card', {
      attrs: {
        "integration": integration,
        "title": integration.provider_name,
        "code": integration.id
      }
    })], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-10 flex justify-center"
  }, [_c('button', {
    staticClass: "px-8 py-2 bg-primary text-white rounded font-semibold disabled:opacity-50",
    attrs: {
      "disabled": !_vm.disabledButton
    },
    on: {
      "click": _vm.goToRoundtable
    }
  }, [_vm._v("\n          Go To Roundtable\n        ")])])]) : _vm._e(), _vm._v(" "), (!_vm.googleClassroomIntegration && !_vm.edLinkIntegrations) ? _c('div', {
    staticClass: "col-start-2 col-end-4 flex flex-col items-center justify-center"
  }, [_c('div', {
    staticClass: "mt-10 text-base font-semibold"
  }, [_vm._v("\n        No integrations to connect\n      ")]), _vm._v(" "), (!_vm.getProfile.google_integration.connected) ? _c('div', [_c('div', {
    staticClass: "mt-5"
  }, [_vm._v("Connect your Google Account")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2.5 flex justify-center"
  }, [_c('button', {
    staticClass: "px-8 py-2 bg-primary text-white rounded font-semibold",
    on: {
      "click": _vm.connectGoogleClassroom
    }
  }, [_vm._v("\n            Connect\n          ")])])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-021b04fa!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/pages/settings/studentSettings.vue
// module id = 1040
// module chunks = 61